module.exports = __webpack_public_path__ + "static/media/edutrea.65b5fd25.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/sponsors/edutrea.png
// module id = 457
// module chunks = 0